<template>
  <div id="app" v-if="styles[opp]">
    <transition name="loading">
      <div class="loading" v-if="loading"
      :style="`background-image: linear-gradient(${styles[opp].background.end}, ${styles[opp].background.start})`">
        <i class="fas fa-fish"/>
        <div class="lds-ripple"><div></div><div></div></div>
      </div>
    </transition>
    <img class="background" :style="`background-image: linear-gradient(${styles[opp].background.start}, ${styles[opp].background.end})`"/>
    <img :src="`../static/img/${opp}/up.svg`" class="up"/>
    <div id="app-content" style="min-height:100%">
      <section id="content" class="min">
        <img :src="`../static/img/${opp}/${backgroundImg || 'portrait_background'}.svg`" v-parallax="{direction: 'up', start:0, end:0}"/>
        <div id="logo">
          <img :src="`../static/img/${opp}/logo.svg`"/>
        </div>
          <page-dashboard :opp="opp" :colors="styles[opp]" @loaded="loading = false"/>
        <img :src="`../static/img/${opp}/down.svg`" class="down"/>
      </section>
    </div>
  </div>
</template>

<script>
import PageDashboard from './pages/PageDashboard'
export default {
  name: 'App',
  components: {PageDashboard},
  created () {
    this.loading = true
    this.opp = this.$route.path.replace(/\//g, '')
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.setBgImg)
      this.setBgImg()
    })
  },
  data () {
    return {
      opp: '',
      loading: true,
      ships: undefined,
      backgroundImg: '',
      styles: {
        anacef: {
          background: { start: '#FBE43D', end: '#D1622E' }
        },
        oppao: {
          background: { start: '#009ED6', end: '#3B6895' }
        },
        opplugo: {
          background: { start: '#EEF5F7', end: '#4A89AD' }
        },
        opromar: {
          background: { start: '#6FA289', end: '#88C392' }
        }
      }
    }
  },
  computed: {
  },
  methods: {
    setBgImg () {
      this.backgroundImg = ''
      var html = document.documentElement
      var body = document.getElementById('content')
      var winHeight = window.innerHeight
      var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
      var width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth)
      this.backgroundImg = ((winHeight > width) ? 'portrait' : 'landscape') + '_background'
      if (width < (height / 3)) {
        this.backgroundImg += '_long'
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
.lds-ripple {
  align-self:center;
  display: inline-block;
  position: relative;
  width: 50vw;
  height: 50vw;
}
.lds-ripple div {
  position: absolute;
  border: .5em solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 25vw;
    left: 25vw;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 50vw;
    height: 50vw;
    opacity: 0;
  }
}
.loading{
  display: flex;
  position: fixed;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  vertical-align: middle;
  z-index: 99999;
  background: #333333;
  transition: opacity .8s ease;
}

.loading-enter {
  opacity: 0;
}

.loading-leave-active {
  opacity: 0;
}

.loading-enter .loading-container,
.loading-leave-active .loading-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.fa-fish{
  align-self:center;
  display: inline-block;
  position: fixed;
  width: 50vw;
  height: 50vw;
  font-size: 20vw;
  animation: fish 1000ms infinite;
  animation-timing-function: linear;
  color:white;
}

@keyframes fish {
  0% { transform: rotate(15deg); }
  50% { transform: rotate(-15deg); }
  100% { transform: rotate(15deg); }
}

</style>



// WEBPACK FOOTER //
// src/App.vue